import $ from 'jquery'
import { trace } from 'rytm-helpers'


const onVideoModalShow = (e) => {
  const modal = e.currentTarget
  const plyrSelector = modal.dataset.player
  const plyr = plyrSelector ? document.querySelector(plyrSelector) : false
  if (plyr) {
    const modalBody = modal. querySelector(".modal-body")
    if (modalBody) {
      modalBody.innerHTML = plyr.innerHTML
    }
  }
}
const onVideoModalHidden = (e) => {
  const modal = e.currentTarget
  const modalBody = modal. querySelector(".modal-body")
  if (modalBody) {
    modalBody.innerHTML = ""
  }
}


export const initVideoModal = () => {
  $("body").on("show.bs.modal", ".movie-trailer-modal", onVideoModalShow)
  $("body").on("hidden.bs.modal", ".movie-trailer-modal", onVideoModalHidden)
}